<template>
  <div class="home">
	</div>
</template>

<script>
export default {
  name: 'Home',
	mounted() {
		window.location.href = "https://www.rueden.de";
	}
}
</script>
